var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacnner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22462 5C5.54921 5 5 5.54921 5 6.22462V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V6.22462C3 4.44464 4.44464 3 6.22462 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6.22462Z",
    fill: "#3CAE8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4C15 3.44772 15.4477 3 16 3H17.7754C19.5554 3 21 4.44464 21 6.22462V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V6.22462C19 5.54921 18.4508 5 17.7754 5H16C15.4477 5 15 4.55228 15 4Z",
    fill: "#3CAE8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15C20.5523 15 21 15.4477 21 16V17.7754C21 19.5554 19.5554 21 17.7754 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H17.7754C18.4508 19 19 18.4508 19 17.7754V16C19 15.4477 19.4477 15 20 15Z",
    fill: "#3CAE8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15C4.55228 15 5 15.4477 5 16V17.7754C5 18.4508 5.54921 19 6.22462 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H6.22462C4.44464 21 3 19.5554 3 17.7754V16C3 15.4477 3.44772 15 4 15Z",
    fill: "#3CAE8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z",
    fill: "#3CAE8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacnner);
export default __webpack_public_path__ + "static/media/sacnner.28f6814c8a9b119d4daa2c769a39b021.svg";
export { ForwardRef as ReactComponent };